<section class='hero is-primary is-fullheight'>
    <div class='hero-body'>
        <div class='container has-text-centered'>
            <img src='install480loop.gif' class="installvid"/>
            <h1 class='title has-text-weight-bold appfont'>
                <img src='logo192.png' alt="" class="installicon"/> {$displayName}
            </h1>
            Please use the <b>Add to Homescreen</b> functionality to begin using {$displayName}
            <p />
        </div>
    </div>
</section>

<style>
    .progress {
        width: 15em;
        margin: auto;
    }
</style>